import { Select } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'utils/cops-moment';
import { cacheLocale } from 'utils/i18n';

const { Option } = Select;

const StyledSelect = styled(Select)`
  width: 65% !important;
  font-size: 16px;
  font-weight: 400;
`;
const LocaleToggle = ({
  locale,
  setLocale,
  supportedLanguages,
  toggleDefinitionMode,
}) => {
  const [currentLocale, setCurrentLocale] = useState(localStorage.getItem('locale') || locale);

  const handleToggle = (value) => {
    if (value === 'definition') {
      localStorage.setItem('definitionModeEnabled', true);
      toggleDefinitionMode();
    } else {
      localStorage.setItem('definitionModeEnabled', false);
      setCurrentLocale(value);
      setLocale(value);
      moment.locale(value);
      cacheLocale(value);
    }
  };

  useEffect(() => {
    const handleStorageChange = () => {
      const newLocale = localStorage.getItem('locale');
      if (newLocale && newLocale !== locale) {
        setCurrentLocale(newLocale);
        setLocale(newLocale);
        moment.locale(newLocale);
        cacheLocale(newLocale);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // getPopupContainer garantees that the select is rendered into the popover,
  // so scrolling/selecting/.. does not close the popover
  // https://codepen.io/anon/pen/xVBOVQ?editors=001
  return (
    <StyledSelect
      value={JSON.parse(localStorage.getItem('definitionModeEnabled')) ?
        'definition' :
        currentLocale
      }
      onChange={handleToggle}
      getPopupContainer={triggerNode => triggerNode.parentNode}
    >
      {supportedLanguages?.map(s =>
        <Option value={s.key} key={s.key}>
          {/* eslint-disable-next-line */}
          {`${s.key.split(/[_-]+/)[0]} ${s.key.split(/[_-]+/)[1] ? `(${s.key.split(/[_-]+/)[1]})` : ''}`}
        </Option>,
      )}
    </StyledSelect>
  );
};

LocaleToggle.propTypes = {
  locale: PropTypes.string,
  setLocale: PropTypes.func.isRequired,
  supportedLanguages: PropTypes.array,
  toggleDefinitionMode: PropTypes.func,
};

export default LocaleToggle;
